module.exports = __webpack_public_path__ + "img/600.7078bec3.png";